import React, { ReactElement } from 'react';
import { Helmet } from 'react-helmet';
import { createKey } from 'b2b-apps/shop/common/utils/key/key';
import { MetaTagType } from 'b2b-apps/shop/content/components/ModularPage';
import { ComponentType, Props } from './';

export const Page: ComponentType = ({
  title,
  titleTemplate,
  defaultTitle,
  children,
  className,
  metaTags,
  mptId,
}: Props): ReactElement => {
  const dataAttributes: Record<string, any> = {};

  if (mptId) {
    dataAttributes['data-mpt-id'] = mptId;
  }

  return (
    <div {...dataAttributes} className={className}>
      <Helmet titleTemplate={titleTemplate} defaultTitle={defaultTitle}>
        <title>{title}</title>
        {metaTags
          && metaTags.map((el: MetaTagType, index: number) => el.name && el.content ? (
              <meta
                key={createKey('meta', 'tag', index)}
                name={el.name}
                content={el.content}
                {...(el.property && { property: el.property }) }
              />
          ) : null)}
      </Helmet>

      {children}
    </div>
  );
};
